// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"885":"2dfc4bc5","966":"2dfc4bc5"}[chunkId] + ".chunk.css";
};